import Alert, { AlertProps } from "@mui/material/Alert";
import Snackbar, { SnackbarProps } from "@mui/material/Snackbar";
import { observer } from "mobx-react";

export interface NotificationProps {
  message: string;
  open: boolean;
  setOpen: (state: boolean) => void;
  snackbarProps?: SnackbarProps;
  alertProps?: AlertProps;
}

const Notification = observer((props: NotificationProps) => {
  const { open, setOpen } = props;

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <Snackbar open={open} onClose={handleClose} anchorOrigin={{ vertical: "top", horizontal: "right" }} autoHideDuration={15000} {...props.snackbarProps} sx={{ top: "32px" }}>
      <Alert onClose={handleClose} severity={props?.alertProps?.severity || "info"} sx={{ width: "100%", maxWidth: "600px" }} {...props.alertProps}>
        {props.message}
      </Alert>
    </Snackbar>
  );
});

export default Notification;
